import React from "react";
import PropTypes from "prop-types";
import "../css/Products.css";

/**
 * Products component
 */
class Products extends React.Component {
  static displayName = "Products";
  static propTypes = {
    className: PropTypes.string,
    products: PropTypes.object,
    category: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Products";
  }

  /**
   * @override
   */
  render() {
    return (
      <table className={`${this.className} ${this.props.className || ""}`}>
        <thead align="left">
          <tr>
            <th
              dangerouslySetInnerHTML={{
                __html: this.props.category.LabelArtID,
              }}
            />
            <th
              dangerouslySetInnerHTML={{
                __html: this.props.category.LabelDesignation,
              }}
            />
            <th
              dangerouslySetInnerHTML={{
                __html: this.props.category.LabelUnit,
              }}
            />
          </tr>
        </thead>
        <tbody>
          <tr />
          {this.props.products.filter(Boolean).map((product) => {
            return (
              <tr key={product.ID}>
                <td>{product.ArtID}</td>
                <td>
                  {product.file().url && (
                    <a
                      href={product.file().url}
                      rel="noopener noreferrer"
                      className={`${this.className}__label`}
                      target="_blank"
                    >
                      {product.Label}
                    </a>
                  )}
                  {!product.file().url && <span>{product.Label}</span>}
                </td>
                <td>{product.Densite}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js